import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'gatsby';

import Feature from 'components/feature';
import { AFEX } from 'config';

import {
  authLinksContainer,
  loginLink,
  signUpLink,
  redTheme,
  whiteTheme,
} from './scss/AuthLinks.module.scss';

const AuthLinks = ({ theme, className }) => {
  const computedTheme = {
    white: whiteTheme,
    red: redTheme,
  }[theme];

  return (
    <div
      className={classNames(
        authLinksContainer,
        className,
        'd-none',
        'd-sm-block'
      )}
    >
      <Feature enabled={false}>
        <Link to="/" className={classNames(loginLink, computedTheme)}>
          Log in
        </Link>
      </Feature>
      <a
        href={AFEX.SIGNUP_LINK}
        className={classNames(signUpLink, computedTheme)}
        target="_blank"
        rel="noopener noreferrer"
      >
        Sign up
      </a>
    </div>
  );
};

AuthLinks.propTypes = {
  theme: PropTypes.oneOf(['red', 'white']),
  className: PropTypes.string,
};

AuthLinks.defaultProps = {
  theme: 'white',
  className: '',
};

export default AuthLinks;
